import {
  getConexion,
  postConexion,
  putConexion,
  postConexionFile,
} from '../../conexion/Conexion';

export const getAllProviders = () => async () => {
  const providers = await getConexion('proveedor/getAllProveedor');
  return providers;
};

export const getTradeDashboardMaster = async (objMaster: any) => {
  const info = await postConexion('cash/getTradesByBusinessId', objMaster);
  return info;
};

export const getDashboardProvider = async (objProvider: any) => {
  const info = await postConexion('cash/getTradesPerProveedor', objProvider);
  return info;
};

// export const getDetailDashboard = async (objProvider: any) => {
//   const providers = await postConexion(
//     'cash/getDecissionsByRelation',
//     objProvider
//   );
//   return providers;
// };

export const getEstadoTrade = async (obj: any) => {
  const value = {
    decissionsId: obj,
  };
  const info = await postConexion('cash/getEstadoTradeByDecissionsId', value);
  return info;
};

export const updateTrade = async (obj: any) => {
  const info = await putConexion('cash/updateEstadoTrade', obj);
  return info;
};

export const updateMultipleTrade = async (obj: any) => {
  const info = await putConexion('cash/updateMultipleEstados', obj);
  return info;
};
export const updateMultipleEstadosPilot = async (obj: any) => {
  const info = await putConexion('cash/updateMultipleEstadosPilot', obj);
  return info;
};

export const updateEfectivoMaximo = async (obj: any) => {
  const info = await putConexion('cash/updateEfeMax', obj);
  return info;
};

export const uploadDocument = async (obj: any): Promise<void> => {
  const file = await postConexionFile(
    'cash/uploadEvidenciaTrade',
    obj.file,
    obj.type,
    obj.id,
    'application/pdf'
  );
  return file;
};

export const uploadMultipleDocument = async (obj: any): Promise<void> => {
  const file = await postConexionFile(
    'cash/uploadMultEvidenciaTrade',
    obj.file,
    obj.type,
    obj.id,
    'application/pdf'
  );
  return file;
};

export const getDocument = async (obj: any) => {
  const info = await postConexion('cash/getEvidenciaTrade', obj);
  return info;
};
